module.exports = __webpack_public_path__ + "static/media/404-en.1412a522.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404-en.svg
// module id = 808
// module chunks = 7